module.exports = __webpack_public_path__ + "img/lotteryTickets.770c8ffd.png";